import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import {
    ButtonController,
    IButtonControllerOptions,
} from '../../../../Common/ButtonController';
import { AnimationContents } from '../../../../../AnimationContents';
import { AppStateEnum, GameModel } from '../../../../Models/Game/GameModel';
import { GameLogic } from '../../../../Logic/GameLogic';

export class AchievementsController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super('AchievementsController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.ACHIEVEMENTS_JSON,
            libraryName: 'main',
            childControllers: {
                closeButton: {
                    instanceName: 'window.container.btn_close',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.gotoAndPlay('window close');
                            this.$queue.get('hide').addToQueue();
                        },
                    },
                },
            },
            queue: {
                hide: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => {
                        if (this.$model.appState === AppStateEnum.game) {
                            this._gameLogic.showGamePause();
                        } else {
                            this._gameLogic.resetMenu();
                        }
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndPlay('window initialization');

        const textArray = [
            'proactivity',
            'responsibility',
            'openness',
            'participation',
        ];

        textArray.forEach((item: string) => {
            const text = this.getDisplayObjectByQuery(
                `window.container.${item}.${item}_text`
            )[0] as any;

            text.style.wordWrap = true;
            text.style.wordWrapWidth = 550;

            const header = this.getDisplayObjectByQuery(
                `window.container.${item}.${item}_header`
            )[0] as any;

            header.style.wordWrap = true;
            header.style.wordWrapWidth = 550;
        });

        this.$model.collectAchievements.forEach((item: string) => {
            this.gotoAndStopByQuery(
                `window.container.${item.toLowerCase()}`,
                'open',
                false
            );

            const text = this.getDisplayObjectByQuery(
                `window.container.${item.toLowerCase()}.${item.toLowerCase()}_text1`
            )[0] as any;

            text.style.wordWrap = true;
            text.style.wordWrapWidth = 550;

            const header = this.getDisplayObjectByQuery(
                `window.container.${item.toLowerCase()}.${item.toLowerCase()}_header1`
            )[0] as any;

            header.style.wordWrap = true;
            header.style.wordWrapWidth = 550;
        });
    }

    protected onLandscape(): void {
        this.display.scale.set(1.1);
        this.display.y = 20;
    }
}
